<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un laboratoire..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="raisonSociale">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> raisonSociale</th>
                        <td mat-cell *matCellDef="let element"> {{ element.raisonSociale }}</td>
                    </ng-container>
                    <ng-container matColumnDef="capital">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Capital</th>
                        <td mat-cell *matCellDef="let element"> {{ element.capital }}</td>
                    </ng-container>
                    <ng-container matColumnDef="adresseMail">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mail</th>
                        <td mat-cell *matCellDef="let element"> {{ element.adresseMail }}</td>
                    </ng-container>
                    <ng-container matColumnDef="tva">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TVA</th>
                        <td mat-cell *matCellDef="let element"> {{ element.tva }}</td>
                    </ng-container>
                    <ng-container matColumnDef="ice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ICE</th>
                        <td mat-cell *matCellDef="let element"> {{ element.ice }}</td>
                    </ng-container>

                    <!-- Client Column -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }} </td>                 
                      </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="adresse">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Address</th>
                        <td mat-cell *matCellDef="let element"> {{ element.adresse }}</td>
                    </ng-container>

                    <!-- City Column -->
                    <ng-container matColumnDef="telephone">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Telephone</th>
                        <td mat-cell *matCellDef="let element"> {{ element.telephone }}</td>
                    </ng-container>

                    <!-- Job Column -->
                    <ng-container matColumnDef="fax">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FAX</th>
                        <td mat-cell *matCellDef="let element"> {{ element.fax }}</td>
                    </ng-container>

                    <!-- Phone Column -->
                    <ng-container matColumnDef="siteWeb">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Site Web</th>
                        <td mat-cell *matCellDef="let element"> {{ element.siteWeb }}</td>
                    </ng-container>
                    <ng-container matColumnDef="registreCommerce">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Registre Commerce</th>
                        <td mat-cell *matCellDef="let element"> {{ element.registreCommerce }}</td>
                    </ng-container>
                    <ng-container matColumnDef="patente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Patente</th>
                        <td mat-cell *matCellDef="let element"> {{ element.patente }}</td>
                    </ng-container>
                    <ng-container matColumnDef="cnss">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cnss</th>
                        <td mat-cell *matCellDef="let element"> {{ element.cnss }}</td>
                    </ng-container>
                    <ng-container matColumnDef="i_f">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> i_f</th>
                        <td mat-cell *matCellDef="let element"> {{ element.i_f }}</td>
                    </ng-container>
                    <ng-container matColumnDef="logo1">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Logo</th>
                        <td mat-cell *matCellDef="let element">
                          <img *ngIf="element.logo1" [src]="getSafeImageUrl(element.logo1)" alt="Logo" width="200" height="200">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="dureeEnJours">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Duree En Jours</th>
                        <td mat-cell *matCellDef="let element"> {{ element.dureeEnJours }}</td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Laboratoire
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="updatePoc()">
                <div class="row">
                    <!-- Form fields here -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Raison Sociale</mat-label>
                            <input matInput formControlName="raisonSociale" placeholder="Ex. MonLaboratoire">
                            <mat-error *ngIf="editForm.get('raisonSociale')?.hasError('required')">Raison Sociale is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>ICE</mat-label>
                            <input matInput formControlName="ice" placeholder="Ex. 123456789">
                            <mat-error *ngIf="editForm.get('ice')?.hasError('required')">ICE is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Type</mat-label>
                            <input matInput formControlName="type" placeholder="Ex. Public">
                            <mat-error *ngIf="editForm.get('type')?.hasError('required')">Type is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Capital</mat-label>
                            <input matInput formControlName="capital" placeholder="Ex. 500000">
                            <mat-error *ngIf="editForm.get('capital')?.hasError('required')">Capital is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>TVA</mat-label>
                            <input matInput formControlName="tva" placeholder="Ex. 20%">
                            <mat-error *ngIf="editForm.get('tva')?.hasError('required')">TVA is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse Mail</mat-label>
                            <input type="email" matInput formControlName="adresseMail" placeholder="Ex. labo@domain.com">
                            <mat-error *ngIf="editForm.get('adresseMail')?.hasError('required')">Email is required</mat-error>
                            <mat-error *ngIf="editForm.get('adresseMail')?.hasError('email')">Invalid email format</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="telephone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="editForm.get('telephone')?.hasError('required')">Téléphone is required</mat-error>
                            <mat-error *ngIf="editForm.get('telephone')?.hasError('pattern')">Téléphone format must be +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Fax</mat-label>
                            <input matInput formControlName="fax" placeholder="Ex. +123-0123456789">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Site Web</mat-label>
                            <input matInput formControlName="siteWeb" placeholder="Ex. www.monlaboratoire.com">
                            <mat-error *ngIf="editForm.get('siteWeb')?.hasError('required')">Website is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Registre de Commerce</mat-label>
                            <input matInput formControlName="registreCommerce" placeholder="Ex. 12345">
                            <mat-error *ngIf="editForm.get('registreCommerce')?.hasError('required')">Registre de Commerce is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Patente</mat-label>
                            <input matInput formControlName="patente" placeholder="Ex. 67890">
                            <mat-error *ngIf="editForm.get('patente')?.hasError('required')">Patente is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>CNSS</mat-label>
                            <input matInput formControlName="cnss" placeholder="Ex. 123456789">
                            <mat-error *ngIf="editForm.get('cnss')?.hasError('required')">CNSS is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>IF</mat-label>
                            <input matInput formControlName="i_f" placeholder="Ex. 12345">
                            <mat-error *ngIf="editForm.get('i_f')?.hasError('required')">IF is required</mat-error>
                        </mat-form-field>
                    </div>
<div class="col-sm-6">
  <mat-form-field class="mb-25" appearance="outline">
    <mat-label>Logo</mat-label>

    <!-- Fake input pour afficher le nom du fichier sélectionné -->
    <input matInput
           [value]="selectedLogoName"
           placeholder="Choisir un logo"
           readonly>

    <!-- Vrai input file caché -->
    <input type="file"
           accept="image/*"
           hidden
           #fileInput
           (change)="onLogoSelected1($event)">

    <!-- Bouton upload -->
    <button mat-icon-button
            matSuffix
            type="button"
            (click)="fileInput.click()">
      <mat-icon>upload</mat-icon>
    </button>

    <mat-error *ngIf="editForm.get('logo1')?.hasError('required')">
      Logo is required
    </mat-error>
  </mat-form-field>

  <!-- Aperçu du logo -->
  <img *ngIf="logoPreview"
       [src]="logoPreview"
       alt="Logo preview"
       width="150"
       height="150"
       style="margin-top:10px; object-fit:contain;">
</div>


                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <textarea matInput formControlName="adresse" placeholder="Ex. 1er étage apt n°2, Résidence BAB ELKHEIR"></textarea>
                            <mat-error *ngIf="editForm.get('adresse')?.hasError('required')">Adresse is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Duree En Jours</mat-label>
                            <input matInput formControlName="dureeEnJours" placeholder="Ex. 3">
                            <mat-error *ngIf="editForm.get('dureeEnJours')?.hasError('required')">
                                Duree is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-primary btn-sm">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-content>
      <div class="row">
        <h5 class="px-3 fw-bold">Détails du laboratoire :</h5>

        <!-- Raison Sociale -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Raison Sociale :</div>
          <p>{{ labo?.raisonSociale }}</p>
        </div>

        <!-- ICE -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">ICE :</div>
          <p>{{ labo?.ice }}</p>
        </div>

        <!-- Type -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Type :</div>
          <p>{{ labo?.type }}</p>
        </div>

        <!-- Capital -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Capital :</div>
          <p>{{ labo?.capital }} MAD</p>
        </div>

        <!-- Email -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Adresse Mail :</div>
          <p>{{ labo?.adresseMail }}</p>
        </div>

        <!-- Téléphone -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Téléphone :</div>
          <p>{{ labo?.telephone }}</p>
        </div>

        <!-- Fax -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Fax :</div>
          <p>{{ labo?.fax }}</p>
        </div>

        <!-- Site Web -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Site Web :</div>
          <p>
            <a *ngIf="labo?.siteWeb" [href]="labo?.siteWeb" target="_blank">
              {{ labo?.siteWeb }}
            </a>
          </p>
        </div>

        <!-- Registre de Commerce -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Registre de Commerce :</div>
          <p>{{ labo?.registreCommerce }}</p>
        </div>

        <!-- Patente -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Patente :</div>
          <p>{{ labo?.patente }}</p>
        </div>

        <!-- CNSS -->
        <div class="col-sm-6 col-lg-4 border-top p-3" *ngIf="labo?.cnss">
          <div class="fw-bold">CNSS :</div>
          <p>{{ labo?.cnss }}</p>
        </div>

        <!-- IF -->
        <div class="col-sm-6 col-lg-4 border-top p-3" *ngIf="labo?.i_f">
          <div class="fw-bold">Identifiant Fiscal (IF) :</div>
          <p>{{ labo?.i_f }}</p>
        </div>

        <!-- TVA -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">TVA :</div>
          <p>{{ labo?.tva }} %</p>
        </div>

        <!-- Durée en Jours -->
        <div class="col-sm-6 col-lg-4 border-top p-3">
          <div class="fw-bold">Durée en jours :</div>
          <p>{{ labo?.dureeEnJours }}</p>
        </div>

        <!-- Adresse -->
        <div class="col-sm-6 col-lg-8 border-top p-3">
          <div class="fw-bold">Adresse :</div>
          <p>{{ labo?.adresse }}</p>
        </div>

        <!-- Logos -->
<div class="col-sm-6 col-lg-4 border-top p-3" *ngIf="labo?.logoFullUrl">
  <div class="fw-bold">Logo :</div>
  <img 
    [src]="labo?.logoFullUrl" 
    alt="Logo" 
    class="img-fluid border rounded p-2" 
    width="150"
    height="150"
  />
</div>



        <div class="col-sm-6 col-lg-4 border-top p-3" *ngIf="labo?.logo2">
          <div class="fw-bold">Logo 2 :</div>
          <img [src]="labo?.logo2" alt="Logo 2" class="img-fluid border rounded p-2" />
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Nouveau laboratoire
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveLabo()">
                <div class="row">
                    <!-- Form fields for Laboratory -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Raison sociale</mat-label>
                            <input matInput formControlName="raisonSociale" placeholder="Ex. Laboratoire Dupont">
                            <mat-error *ngIf="form.get('raisonSociale')?.hasError('required')">La raison sociale est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>ICE</mat-label>
                            <input matInput formControlName="ice" placeholder="Ex. 123456789">
                            <mat-error *ngIf="form.get('ice')?.hasError('required')">L'ICE est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Type</mat-label>
                            <input matInput formControlName="type" placeholder="Ex. Type A">
                            <mat-error *ngIf="form.get('type')?.hasError('required')">Le type est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Capital</mat-label>
                            <input matInput formControlName="capital" placeholder="Ex. 1000000">
                            <mat-error *ngIf="form.get('capital')?.hasError('required')">Le capital est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>TVA</mat-label>
                            <input matInput formControlName="tva" placeholder="Ex. 20%">
                            <mat-error *ngIf="form.get('tva')?.hasError('required')">Le tva est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="adresseMail" placeholder="Ex. info@laboratoire.com">
                            <mat-error *ngIf="form.get('adresseMail')?.hasError('required')">L'email est obligatoire</mat-error>
                            <mat-error *ngIf="form.get('adresseMail')?.hasError('email')">Le format de l'email est invalide</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="telephone" placeholder="Ex. +212 5 23 45 67 89">
                            <mat-error *ngIf="form.get('telephone')?.hasError('required')">Le téléphone est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Site Web</mat-label>
                            <input matInput formControlName="siteWeb" placeholder="Ex. www.laboratoire.com">
                            <mat-error *ngIf="form.get('siteWeb')?.hasError('required')">Le site web est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Registre de commerce</mat-label>
                            <input matInput formControlName="registreCommerce" placeholder="Ex. 123456">
                            <mat-error *ngIf="form.get('registreCommerce')?.hasError('required')">Le registre de commerce est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Patente</mat-label>
                            <input matInput formControlName="patente" placeholder="Ex. 654321">
                            <mat-error *ngIf="form.get('patente')?.hasError('required')">La patente est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>CNSS</mat-label>
                            <input matInput formControlName="cnss" placeholder="Ex. 001234567">
                            <mat-error *ngIf="form.get('cnss')?.hasError('required')">La CNSS est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>IF</mat-label>
                            <input matInput formControlName="i_f" placeholder="Ex. 12345">
                            <mat-error *ngIf="form.get('i_f')?.hasError('required')">L'IF est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
  <mat-form-field class="mb-25" appearance="outline">
    <mat-label>Logo</mat-label>

    <!-- Fake input to show filename -->
    <input matInput
           [value]="selectedLogoName"
           placeholder="Choisir un logo"
           readonly>

    <!-- Real file input -->
    <input type="file"
           accept="image/*"
           hidden
           #fileInput
           (change)="onLogoSelected($event)">

    <button mat-icon-button
            matSuffix
            type="button"
            (click)="fileInput.click()">
      <mat-icon>upload</mat-icon>
    </button>

    <mat-error *ngIf="form.get('logo1')?.hasError('required')">
      Le logo est obligatoire
    </mat-error>
  </mat-form-field>

  <!-- Preview -->
  <img *ngIf="logoPreview"
       [src]="logoPreview"
       alt="Logo preview"
       width="120"
       height="120"
       style="margin-top:10px; object-fit:contain;">
</div>

                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <input matInput formControlName="adresse" placeholder="Ex. 123 Rue des Laboratoires">
                            <mat-error *ngIf="form.get('adresse')?.hasError('required')">L'adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Fax</mat-label>
                            <input matInput formControlName="fax" placeholder="Ex. +212 5 23 45 67 90">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Duree En jours </mat-label>
                            <input matInput formControlName="dureeEnJours" placeholder="Ex. Laboratoire Dupont">
                            <mat-error *ngIf="form.get('dureeEnJours')?.hasError('required')">Duree En jours est obligatoire</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-success btn-sm" [disabled]="form.invalid">Sauvegarder</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
